// src/components/features/Structure/components/StructureStep3FootingType.jsx
// Step 3: Type of Footing — simple Radio card style

import {
  Box,
  Flex,
  Text,
  Radio,
  Button,
  VStack,
} from "@chakra-ui/react";

const FOOTING_TYPES = [
  {
    value: "pile",
    label: "Pile Footing",
    sub: "Deep foundation — ideal for loose/soft soil or heavy structures",
  },
  {
    value: "isolated",
    label: "Isolated Footing",
    sub: "Individual column footings — for medium to hard soil with RCC frame",
  },
];

export default function StructureStep3FootingType({
  formData, setFormData, onNext, onBack, isLastStep, onSubmit, viewMode,
}) {
  const footingType = formData?.footingType || "";

  const handleNext = () => {
    if (!viewMode && !footingType) return;
    if (isLastStep) onSubmit();
    else onNext();
  };

  return (
    <Box
      h="600px"
      w="100%"
      maxW="400px"
      mx="auto"
      display="flex"
      flexDirection="column"
      justifyContent="space-between"
      px={4}
      py={6}
    >
      <Box
        flex="1"
        minH="0"
        overflowY="auto"
        overflowX="hidden"
        pr={2}
        css={{
          "&::-webkit-scrollbar": { width: "6px" },
          "&::-webkit-scrollbar-thumb": { background: "#cbd5e0", borderRadius: "10px" },
          "& *": { pointerEvents: viewMode ? "none" : "auto" },
        }}
      >
        <VStack spacing={4} align="stretch">
          <Box textAlign="center">
            <Text fontSize="17px" fontWeight="600" color="gray.800">Type of Footing</Text>
            <Text fontSize="12px" color="gray.500" mt={1}>
              Select the foundation type suitable for your structure
            </Text>
          </Box>

          <VStack spacing={2} align="stretch">
            {FOOTING_TYPES.map((f) => {
              const isSelected = footingType === f.value;
              return (
                <Box
                  key={f.value}
                  border={isSelected ? "2px solid #319795" : "1px solid #E2E8F0"}
                  borderRadius="10px"
                  px={3}
                  py={2}
                  cursor="pointer"
                  bg={isSelected ? "cyan.50" : "white"}
                  transition="0.2s"
                  _hover={{ borderColor: "cyan.400" }}
                  onClick={() => setFormData({ ...formData, footingType: f.value })}
                >
                  <Flex align="center" gap={3}>
                    <Radio
                      value={f.value}
                      isChecked={isSelected}
                      onChange={() => setFormData({ ...formData, footingType: f.value })}
                      colorScheme="cyan"
                      size="md"
                    />
                    <Box>
                      <Text fontSize="14px" fontWeight="600" color="gray.800">{f.label}</Text>
                      <Text fontSize="11px" color="gray.500">{f.sub}</Text>
                    </Box>
                  </Flex>
                </Box>
              );
            })}
          </VStack>

          {/* Context tip from previous step */}
          {formData?.soilCondition && (
            <Box bg="gray.50" borderRadius="8px" px={3} py={2}>
              <Text fontSize="11px" color="gray.500" textAlign="center">
                {formData.soilCondition === "loose"
                  ? "💡 Pile Footing is recommended for loose soil"
                  : formData.soilCondition === "hard"
                  ? "💡 Isolated Footing is generally suitable for hard soil"
                  : "💡 Consult your structural engineer for medium soil"}
              </Text>
            </Box>
          )}
        </VStack>
      </Box>

      <Flex justify="space-between" gap={3} mt={4} flexShrink={0}>
        <Button
          onClick={onBack}
          variant="solid" bg="white" color="cyan.600"
          border="1px solid" borderColor="cyan.500"
          borderRadius="6px" minW="100px" h="40px"
          fontWeight="500" fontSize="14px"
          _hover={{ bg: "cyan.50" }}
        >
          ← Previous
        </Button>
        <Button
          onClick={handleNext}
          isDisabled={viewMode ? false : !footingType}
          variant="solid"
          bg={(viewMode || footingType) ? "cyan.500" : "gray.300"}
          color="white" borderRadius="6px" minW="100px" h="40px"
          fontWeight="500" fontSize="14px" ml="auto"
          _hover={{ bg: (viewMode || footingType) ? "cyan.600" : "gray.300" }}
          _disabled={{ bg: "gray.300", color: "gray.500", cursor: "not-allowed" }}
        >
          {isLastStep ? "Submit" : "Next →"}
        </Button>
      </Flex>
    </Box>
  );
}